/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

import { types } from 'mobx-state-tree';

export const FetchState = types.optional(types.enumeration('State', ['initial', 'pending', 'done', 'error']), 'initial');



// WEBPACK FOOTER //
// ./src/js/util/ModelUtil.js